import React from 'react';
import {RouteProps} from "react-router";
import {Route} from "react-router-dom";
import {TabItem} from './components/TabItem';
import {content, contentWrapper, root, tabs} from "./styles";
import {TabsRouteProps} from "./types";

export const TabsRoute: React.FC<TabsRouteProps & RouteProps> = ({
    options,
    ...rest
}) => {

    const handleSelect = (key: number) => {
        switch(window.location.pathname){
            case '/':
                return key;
            case '/tsm/':
                return 1;
            case '/air-quality-monitoring/':
                return key;
            case '/air-quality-monitoring/calibrations':
                return !key;
            default:
                return key;
        }
        // if(window.location.pathname == "/")
        //     return key;
        // if(window.location.pathname == "/tsm/")
        //     return 1;
        // if(window.location.pathname == "/air-quality-monitoring/")
        //     return key;
        // if(window.location.pathname == "/air-quality-monitoring/calibrations")
        //     return !key;
    }

    return (
        <div css={root}>
            <div css={tabs}>
                {options.map((x, key) => (
                    <TabItem selected={!handleSelect(key)} option={x} key={key}/>
                ))}
            </div>
            <div css={contentWrapper}>
                <div css={content}>
                    <Route {...rest} />
                </div>
            </div>
        </div>

    )
};